import { Link } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
// Data
import authorsTableData from "layouts/Center-management/data";
import { useEffect, useState } from "react";
import centerService from "services/center-service";
import Notification from "examples/Notifications";
import { AddButton } from "layouts/common/buttons";

const CenterManagement = () => {
  const [centers, setCenters] = useState([]);
  console.log("Centers", centers);
  const [notification, setNotification] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // State for search input

  const handleDelete = async (id) => {
    if (!id) {
      console.error('Error: No id provided for deletion');
      setNotification({
        type: 'error',
        message: 'Invalid center ID for deletion.',
      });
      return;
    }

    try {
      const response = await centerService.delete(id);

      if (response.success === true) {
        // Remove deleted center from list
        setCenters((prevCenters) => prevCenters.filter(center => center.id !== id));

        setNotification({
          type: 'success',
          message: response.message || 'Center deleted successfully.',
        });
      } else {
        setNotification({
          type: 'error',
          message: response.error || 'Failed to delete the center.',
        });
      }
    } catch (error) {
      console.error('Error deleting center:', error);
      setNotification({
        type: 'error',
        message: 'An unexpected error occurred while deleting the center.',
      });
    }
  };


  const { columns, rows } = authorsTableData(centers, handleDelete);

  useEffect(() => {
    getCenters();
  }, []);

  const getCenters = async () => {
    var centerData = await centerService.getAll();
    if (centerData.success == true && centerData.centers) {
      console.log('data', centerData.centers);
      setCenters(centerData.centers);
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex" justifyContent="space-between" alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Centers
                </MDTypography>
                <AddButton link="/centers/create" />

              </MDBox>
              {/* <MDBox mt={3} display="block" alignItems="center" p={2}>
                <TextField
                  label="Search"
                  variant="outlined"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  fullWidth
                  sx={{ maxWidth: 300 }}
                />
              </MDBox> */}
              <Notification notification={notification} setNotification={setNotification} />
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default CenterManagement;
